import { TimerSwitch } from "@/layouts/SejaPago/TimerSwitch";
import { Button, Flex, forwardRef, Icon, Switch, Text, Tooltip } from "@chakra-ui/react";
import ptBR from 'date-fns/locale/pt-BR';
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Controller, useController } from "react-hook-form";
import { Checkbox  } from "barte-design-system";
interface TimeDatePickerInputProps {
  label?: string;
  name: string;
  control: any;
  tooltipText?: string;
  hasSwitch?: boolean;
  disabledState?: boolean;
  register?: any;
  setDisabledState?: (data: boolean) => void;
  startEnabled?: boolean;
  dateSwitchState?: boolean;
  errors?: any;
  setValue?: any;
  timerState: boolean;
  setTimerState: (value: boolean) => void;
  format?: string;
}

export function TimeDatePickerInput({
  label,
  control,
  tooltipText,
  name,
  hasSwitch,
  disabledState,
  startEnabled,
  setDisabledState,
  register,
  dateSwitchState,
  errors,
  setValue,
  timerState,
  setTimerState,
  format,
  ...rest
}: TimeDatePickerInputProps) {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
  });

  const filterPassedTime = (time) => {
    if (!time) return false;
    
    const currentDate = new Date();
    const selectedDate = new Date(time);

    // Verificar se a data é válida
    if (isNaN(selectedDate.getTime())) {
      return false;
    }

    return currentDate.getTime() < selectedDate.getTime();
  };

  const CustomInput = forwardRef(({ value, onClick }, ref) => {
    // Garantir que o value seja uma string válida
    const displayValue = value || "";
    
    return (
      <Button
        onClick={onClick}
        ref={ref}
        {...register}
        name={name}
        p="5px 12px"
        w="100%"
        borderRadius="4px"
        bgColor="transparent"
        border="1px solid"
        borderColor={disabledState ? "newGray.100" : "newGray.200"}
        fontSize="16px"
        disabled={hasSwitch && !disabledState}
        _focus={{
          border: "1px solid",
          borderColor: "blue.200",
        }}
        _hover={{
        }}
        _disabled={{
          cursor: "not-allowed",
        }}
        position="relative"
        color={hasSwitch && !disabledState ? "newGray.200" : "black"}
        fontWeight="500"
      >
        <Text position="absolute" left="10px">
          {displayValue}
        </Text>
      </Button>
    );
  });

  useEffect(() => {
    setValue("timer", selectedDate ?? new Date());
  }, []);

  return (
    <Flex flexDir="column" gap="4px" justifyContent="center"
      m="12px 0"
      p={disabledState ? "16px" : "0 16px"}
      
      >
      <Flex align="center" alignContent="center" alignItems="center" gap="12px">
        {hasSwitch && (
          <Flex h="100%">

            <Checkbox
              defaultChecked={disabledState}
              onChange={() => setDisabledState(!disabledState)}
              label={label}
        
            />

          </Flex>

        )}
     
      </Flex>

      {disabledState && (


        <Flex flexDir="column" alignItems="flex-start" w="100%" align="center" position="relative" justify="space-between">
          <Controller
            name={name}
            control={control}
            defaultValue={selectedDate ?? new Date()}
            render={({ field }: any) => {
              // Validar se a data é válida
              const isValidDate = (date: any): date is Date => {
                return date instanceof Date && !isNaN(date.getTime());
              };

              const getValidDate = (date: any): Date | null => {
                if (!date) return null;
                if (date instanceof Date && isValidDate(date)) {
                  return date;
                }
                if (typeof date === 'string' || typeof date === 'number') {
                  const parsedDate = new Date(date);
                  return isValidDate(parsedDate) ? parsedDate : null;
                }
                return null;
              };

              const selectedDateValue = getValidDate(field.value) || selectedDate || new Date();

              return (
                <DatePicker
                  {...rest}
                  locale={ptBR}
                  onBlur={onBlur}
                  selected={selectedDateValue}
                  wrapperClassName="datePicker"
                  onChange={(date) => { 
                    if (date && isValidDate(date)) {
                      field.onChange(date);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  minDate={new Date()}
                  disabled={hasSwitch && !disabledState}
                  showTimeSelect={format !== "dd/MM/yyyy"}
                  timeFormat={!format ? "HH:mm" : ""}
                  timeIntervals={15}
                  filterTime={filterPassedTime}
                  dateFormat={format || "dd/MM/yyyy HH:mm"}
                  timeCaption="Time"
                  customInput={<CustomInput />}
                  ariaLabelCloseIcon="Fechar"
                  ariaLabelOpenCalendarIcon="Abrir calendário"
                  ariaLabelPreviousMonth="Mês anterior"
                  ariaLabelNextMonth="Próximo mês"
                />
              );
            }}
          />
          {format !== "dd/MM/yyyy" &&

            <TimerSwitch
              expirationDate={disabledState}
              timerState={timerState}
              setTimerState={setTimerState}
              text="Contagem regressiva"
              marginTop="1rem"
              justify="flex-start" 
              gap="6px"
              align="center"
              alignContent="center"
              alignSelf="center"
              w="100%"
            />
          }
          {errors && (
            <Text fontSize=".8rem" color="danger" role="alert">
              {errors?.message}
            </Text>
          )}
        </Flex>

      )}

    </ Flex>
  )
}